import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Results from '../Results';
import { getFolders } from '../../api';
import Loader from '../shared/Loader';
import BreadCrumb from '../BreadCrumb';

const FoldersTab = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [paginationLoading, setPaginationLoading] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [initialData, setInitialData] = useState(null);
  const [breadCrumb, setBreadCrumb] = useState([]);

  useEffect(() => {
    setLoading(true);

    getFolders()
      .then(response => setData(response.data))
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box m="auto" maxWidth="1400px" width="90%">
      {loading && <Loader />}

      <BreadCrumb
        breadCrumb={breadCrumb}
        setBreadCrumb={setBreadCrumb}
        setData={setData}
        setError={setError}
        setLoading={setLoading}
        setInitialData={setInitialData}
        setSelectedFilters={setSelectedFilters}
      />

      <Results
        data={data}
        loading={loading}
        error={error}
        setData={setData}
        setError={setError}
        setLoading={setLoading}
        setPaginationLoading={setPaginationLoading}
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
        initialData={initialData}
        setInitialData={setInitialData}
        paginationLoading={paginationLoading}
        setBreadCrumb={setBreadCrumb}
      />
    </Box>
  );
};

export default FoldersTab;
